<template>
	<modal size="huge">
		<modal-title style="text-align: center; margin-top: 20px">{{
			trans("billing.upgrade_modal_title")
		}}</modal-title>

		<div class="prop-box row mt-2" style="text-align: center; padding-left: 50px; padding-right: 50px">
			<form id="upgrade-form">
				<div class="input-grid mb-3">
					<field
						:label="trans('billing.upgrade_modal_company_vat')"
						@input="getVatInfo"
						type="text"
						name="company_identifier"
						:is-full="true"
						class="full mb-1"
						v-model="vat"
						:asterisk="true"
						:error="firstError('company_identifier')"
					></field>
					<field
						:label="trans('misc.company_name')"
						type="text"
						name="company_name"
						:is-full="true"
						class="full mb-1"
						v-model="name"
						:asterisk="true"
						:error="firstError('company_name')"
					></field>
					<field
						:label="trans('misc.invoice_email')"
						type="email"
						name="invoice_email"
						:is-full="true"
						class="full mb-1"
						v-model="email"
						:asterisk="true"
						:error="firstError('invoice_email')"
					></field>
					<dropdown
						:options="countries"
						:label="trans('misc.address.country')"
						:is-full="true"
						:error="firstError('address_country')"
						v-model="country"
						class="full mb-1"
						id="address_country"
						:asterisk="true"
						style="text-align: left"
					>
						<option :value="option" slot="option" slot-scope="{ option }">{{ option }}</option>
					</dropdown>
					<field type="hidden" name="_token" v-model:value="csrf"></field>
				</div>

				<div class="plan-boxes" style="justify-content: center">
					<div
						:class="['plan-box plan-' + plan.slug, { selected: selected_plan === plan.slug }]"
						v-for="plan in plans"
						style="width: 50%; max-width: 50%"
						@click="selected_plan = plan.slug"
					>
						<span class="selected-hint" v-show="selected_plan === plan.slug">{{
							trans("wizard.steps.plan.plan_selected")
						}}</span>

						<div class="plan-box-main">
							<img
								class="icon"
								:src="asset('images/billing/plan-' + plan.slug + '.svg')"
								:alt="plan.slug"
								width="76"
								height="76"
							/>

							<input type="radio" id="plan" name="plan" :value="plan.slug" v-model="selected_plan" />

							<strong class="title">{{ trans("wizard.steps.plan." + plan.slug + ".name") }}</strong>

							<strong class="price">
								<span
									>{{ getPrice(plan.id) }} <small>{{ currency }}</small></span
								>
								<div style="margin: 0; line-height: 1; margin-top: -10px">
									<small style="font-size: 0.5em">{{ trans("wizard.steps.plan.pricing") }}</small>
								</div>
							</strong>
						</div>

						<ul
							style="
								text-align: left;
								margin: 20px 0 0;
								padding: 0;
								font-size: 14px;
								list-style-type: circle;
							"
						>
							<pre
								v-html="trans('wizard.steps.plan.' + plan.slug + '.features')"
								style="
									font-size: 15px;
									line-height: 1.46;
									-webkit-font-smoothing: antialiased;
									font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
										Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
								"
							></pre>
						</ul>
					</div>
				</div>

				<input
					type="checkbox"
					id="agree_to_terms"
					name="agree_to_terms"
					required="required"
					class="checkbox size-regular type-checkbox has-label is-required"
					@change="toggleTerms()"
				/>
				<span v-html="trans('register.agree_to_terms')"></span>
				<span class="asterisk">*</span>

				<div class="footer mt-2">
					<btn :prevent="false" @clicked="upgradeUserAccount" variant="cta" :disabled="!agree_to_terms">{{
						trans("billing.upgrade")
					}}</btn>
				</div>
			</form>
		</div>

		<modal-footer slot="footer">
			<btn variant="cta" type="text-only" @clicked="close" slot="cancel">{{ trans("actions.cancel") }}</btn>
		</modal-footer>
	</modal>
</template>

<script type="text/babel">
export default {
	props: ["modal"],

	data: function () {
		return {
			errors: {},
			code: null,
			vat: window.user_account.billing_info.vat,
			name: window.user_account.billing_info.name,
			email: window.user_account.billing_info.invoice_email,
			country: window.user_account.billing_info.country,
			company_id: window.user_account.id,
			current_user_id: window.user.id,
			csrf: window.csrfToken,
			currency: window.user_account.settings.system.currency,

			selected_plan: window.user_account.current_plan,
			plans: [],
			plan_prices: [],
			agree_to_terms: false,
			countries: [],
		};
	},

	methods: {
		upgradeUserAccount() {
			axios
				.post(window.routes.api.upgrade_plan.upgrade_inactive, {
					company_id: this.company_id,
					company_identifier: this.vat,
					company_name: this.name,
					invoice_email: this.email,
					address_country: this.country,
					plan: this.selected_plan,
					current_user_id: this.current_user_id,
				})
				.then((response) => {
					window.location.href = window.routes.frontend.upgrade_plan.post_upgrade;
				})
				.catch((error) => {
					if (error.response != undefined) {
						if (error.response.data && error.response.data.errors) {
							this.errors = error.response.data.errors;
						}
					}
				});
		},

		getBillingCountries() {
			axios
				.get(window.routes.api.billing_settings.countries, {})
				.then((response) => {
					this.countries = response.data;
					Vue.nextTick(() => {
						this.has_loaded_first = true;
					});
				})
				.catch((error) => {
					newErrorNotification(null, parseBadResponse(error));
				});
		},

		close() {
			this.$emit("close");
		},

		hasError: function (field) {
			return this.errors[field] !== undefined && this.errors[field].length > 0;
		},

		firstError: function (field) {
			return this.errors[field] !== undefined ? this.errors[field][0] : "";
		},

		//obtain active plans and transform the Object into an Array
		getPlans() {
			axios.get(window.routes.api.plans.index).then((response) => {
				this.plans = Object.values(response.data.plans);
			});
		},

		//obtain plan prices listing
		getPlanPrices() {
			axios.get(window.routes.api.plan_prices.index).then((response) => {
				this.plan_prices = Object.values(response.data.plan_prices);
			});
		},

		//obtain corresponding price for specific plan
		getPrice(planId) {
			const filterPlanId = this.plan_prices.filter(({ plan_id }) => plan_id == planId);
			const filterCurrency = filterPlanId.filter(({ currency }) => currency == this.currency)[0];
			if (filterCurrency != undefined) {
				return filterCurrency["price"];
			} else return null;
		},

		toggleTerms() {
			this.agree_to_terms = !this.agree_to_terms;
		},
	},

	computed: {},

	mounted() {
		this.getPlans();
		this.getPlanPrices();
		this.getBillingCountries();
	},
};
</script>
